module.exports = {"Employee-FAQs":"https://www.notion.so/reallinks/Employee-FAQs-ef630d57ae1d4809bd7199fbf67d521d","Recruiter-FAQs":"https://www.notion.so/reallinks/Recruiter-FAQs-6dae252c79d44868beff263d4e1e9d1c"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/helpURLs.json
// module id = Cxvw
// module chunks = 102